module.exports = __webpack_public_path__ + "static/media/Avatars_Other_New-24.68bb1614.jpg";